import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { AllUsersState } from 'app/library/all-users/models/all-users.state';
import { CertificateRecord } from 'app/library/certificate-record/models/certificate-record';
import { UserCourseCertificatesState } from 'app/library/certificate-record/models/user-course-certificates.state';
import { CertificationProvidersState } from 'app/library/certification-provider/models/certification-providers.state';
import { CertificationsState } from 'app/library/certifications/models/certifications.state';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { TeamCertificationParentNameEnum } from 'app/library/team/enums/team-certification-dialog-type.enum';
import { Team } from 'app/library/team/models/team.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { FeatureSwitchName } from 'app/projects/shared/src/lib/enums/feature-switch.enum';
import { FeatureSwitchPipe } from 'app/projects/shared/src/lib/pipes/feature-switch.pipe';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-team-certification-dialog',
    templateUrl: './team-certification-dialog.component.html',
    styleUrls: ['./team-certification-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TeamCertificationDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    title: string;

    @Input()
    parentType: TeamCertificationParentNameEnum;

    @Input()
    userId: string;

    @Input()
    team: Team;

    @Input()
    isTrackSubTeamProgressActive: boolean;

    @Select(CertificationProvidersState.getTotalCount)
    certificationProvidersTotalCount$: Observable<number>;

    @Select(CertificationProvidersState.getUserIds)
    userIds$: Observable<number[]>;

    @Select(AllUsersState.getEntities)
    allUser$: Observable<User[]>;

    @Select(AllUsersState.getTotalCount)
    allUserTotalCount$: Observable<number>;

    @Select(CertificationsState.getSelectedEntityIds)
    selectedCertificationIds$: Observable<string[]>;

    @Select(UserCourseCertificatesState.getFilteredEntities)
    userCourseCertificates$: Observable<CertificateRecord[]>;

    @Select(UserCourseCertificatesState.getTotalCount)
    userCourseCertificatesTotalCount$: Observable<number>;

    displayedColumns: string[] = ['provider', 'certificationName', 'checkbox', 'name', 'status', 'issueDate', 'expirationDate', 'buttons'];
    ParentType = TeamCertificationParentNameEnum;

    isCertificateOfAttendanceFeatureEnabled: boolean = false;
    isCertificateMgmtFeatureEnabled: boolean = false;
    isGradebookFeatureEnabled: boolean = false;
    profile = this._store.selectSnapshot(UserState.getMyInfo);

    get isCurrentUserTenantAdmin(): boolean {
        return this.profile.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);
    }

    constructor(public dialogRef: MatDialogRef<TeamCertificationDialogComponent>, private _featureSwitchPipe: FeatureSwitchPipe, private _store: Store) {
        super();

        this.isGradebookFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.Gradebook);
        this.isCertificateOfAttendanceFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.CertificateOfAttendance);
        this.isCertificateMgmtFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.CertificateManagement);
    }

    ngOnInit(): void {
    }
}
